import { Divider } from "@mui/material";
import React from "react";

const ReportCertificateHeader = ({
  reportData,
  selectedSections,
}: {
  reportData: any;
  selectedSections: { [key: string]: boolean };
}) => {
  const headerContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #c7c5c5",
    marginBottom: "4px",
  };

  const leftStyle = {
    fontSize: "18px",
    fontWeight: "bold",
  };

  const logoStyle = {
    maxHeight: "40px",
    width: "auto",
    objectFit: "contain" as const,
  };

  const addressContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center" as const,
  };

  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    marginTop: "4px",
    fontSize: "12px",
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap" as const,
  };

  const labelStyle = {
    width: "76px",
    whiteSpace: "nowrap" as const,
    fontSize: "10px",
  };

  const labelFirstStyle = {
    width: "116px",
    marginLeft: "45px",
    whiteSpace: "nowrap" as const,
    fontSize: "10px",
  };

  const valueStyle = {
    fontWeight: "bold",
    whiteSpace: "nowrap" as const,
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const branchStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "4px",
  };

  const isBranch = reportData?.medicalReportCertificateHeader?.locationTypeCode === "BRANCH";

  const showCareOf =
    !isBranch &&
    Boolean(reportData?.medicalReportCertificateHeader?.locationName) &&
    Boolean(reportData?.medicalReportCertificateHeader?.organazationName);

  return (
    <>
      {reportData?.medicalReportCertificateHeader?.locationTypeCode !== "BRANCH" && (
        <>
          <div style={branchStyle}>
            <div style={leftStyle} className="font-size-18">
              <div style={{ textAlign: "center" }}>
                {reportData?.medicalReportCertificateHeader?.locationName}
                <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                  {" "}
                  (
                  {reportData?.medicalReportCertificateHeader?.locationCityName === reportData?.medicalReportCertificateHeader?.locationCity
                    ? reportData?.medicalReportCertificateHeader?.locationCityName
                    : `${reportData?.medicalReportCertificateHeader?.locationCityName} ${reportData?.medicalReportCertificateHeader?.locationCity}`}
                  )
                </span>
              </div>
            </div>
          </div>
          <div style={{ borderBottom: "1px solid #c7c5c5", fontSize: "12px" }}>
            <div className="address-container" style={addressContainerStyle}>
              <div>
                {reportData?.medicalReportCertificateHeader?.locationAddress1} {reportData?.medicalReportCertificateHeader?.locationAddress2}
              </div>
            </div>
            <div
              className="address-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                marginBottom: "4px",
              }}
            >
              {reportData?.medicalReportCertificateHeader?.locationContactInformation}{" "}
              {reportData?.medicalReportCertificateHeader?.locationMobileNumber &&
                `, Mobile No.: ${reportData.medicalReportCertificateHeader?.locationMobileNumber}`}
              {reportData?.medicalReportCertificateHeader?.locationLandLineNumber &&
                `, LandLine No.: ${reportData?.medicalReportCertificateHeader?.locationLandLineNumber}`}
            </div>
          </div>
        </>
      )}
      {selectedSections?.HEADER &&
        reportData?.medicalReportCertificateHeader?.headerEnable && (
          <>
            <div style={headerContainerStyle}>
              <div style={leftStyle} className="font-size-18">
                <div>
                  {showCareOf && <span style={{ marginRight: "4px", fontSize: "14px" }}>C/O</span>}
                  <span
                    style={{
                      fontSize: showCareOf ? "14px" : "18px",
                    }}
                  >
                    {reportData?.medicalReportCertificateHeader?.organazationName}
                  </span>
                  <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {" "}
                    ({reportData?.medicalReportCertificateHeader?.branchName})
                  </span>
                </div>
              </div>
              {reportData?.medicalReportCertificateHeader?.logoServerImage && (
                <div
                  style={{
                    marginTop: "6px",
                  }}
                >
                  <img
                    src={`data:image/png;base64,${reportData?.medicalReportCertificateHeader?.logoServerImage}`}
                    alt="Logo"
                    style={logoStyle}
                  />
                </div>
              )}
            </div>
            <div
              style={{ borderBottom: "1px solid #c7c5c5", fontSize: "12px" }}
            >
              <div className="address-container" style={addressContainerStyle}>
                <div>
                  {reportData?.medicalReportCertificateHeader?.address1}{" "}
                  {reportData?.medicalReportCertificateHeader?.address2}
                </div>
              </div>
              <div
                className="address-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  marginBottom: "4px",
                }}
              >
                {
                  reportData?.medicalReportCertificateHeader
                    ?.branchContactInformation
                }{" "}
                {reportData?.medicalReportCertificateHeader?.mobileNumber &&
                  `, Mobile No.: ${reportData?.medicalReportCertificateHeader?.mobileNumber}`}{" "}
                {reportData?.medicalReportCertificateHeader?.landLineNumber &&
                  `, Landline number: ${reportData?.medicalReportCertificateHeader?.landLineNumber}`}
              </div>
            </div>
          </>
        )}
      {reportData?.medicalReportCertificateHeader && (
        <>
          <div style={gridContainerStyle}>
            <div style={rowStyle}>
              <span style={labelStyle}>EMR # </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.patientNumber}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelFirstStyle}>DATE </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.caseDate || ""}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>NAME </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.fullName}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelFirstStyle}>OPD CASE # </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.caseNumber}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>GENDER / AGE </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.gender}
                {(reportData?.medicalReportCertificateHeader?.ageYear > 0 ||
                  reportData?.medicalReportCertificateHeader?.ageMonth > 0 ||
                  reportData?.medicalReportCertificateHeader?.ageDay > 0) && " / "}
                {reportData?.medicalReportCertificateHeader?.ageYear > 0 && reportData?.medicalReportCertificateHeader?.ageYear + "y "}
                {reportData?.medicalReportCertificateHeader?.ageMonth > 0 && reportData?.medicalReportCertificateHeader?.ageMonth + "m "}
                {reportData?.medicalReportCertificateHeader?.ageDay > 0 && reportData?.medicalReportCertificateHeader?.ageDay + "d"}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelFirstStyle}>CONSULTING DOCTOR </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.consultingDoctorName}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>ADDRESS </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.area?.length > 0 ? reportData?.medicalReportCertificateHeader?.area + ", " : ""}
                {reportData?.medicalReportCertificateHeader?.city}
              </span>
            </div>

            <div style={rowStyle}>
              <span style={labelFirstStyle}>REG NO </span>
              <span style={valueStyle}>
                : {reportData?.medicalReportCertificateHeader?.registrationNumber}
              </span>
            </div>
          </div>
          <Divider />
        </>
      )}
    </>
  );
};

export default ReportCertificateHeader;
